import { ApiResponse, postRequest } from "@/data/apiClient";

export interface LoginRequest {
  app?: string;
  userName: string;
  password: string;
  clientKey: string;
  clientAddress: string;
}

export interface LoginResponse {
  ok: boolean;
  clientKey: string;
  userId: string;
  sessionId: string;
  loginToken: string;
  expirationTimestamp: string;
  errorMessage: string;
}

export async function passwordLogin(
  userName: string,
  password: string,
  clientKey: string | undefined,
  clientAddress: string,
  app?: string
): Promise<ApiResponse<LoginResponse>> {
  return postRequest("user/login", {
    userName: userName.trim(),
    password,
    clientKey,
    clientAddress,
    app,
  });
}
